import AgentOpsQueue from './agent-ops-queue';
import Authentication from './authentication';
import Billing from './billing';
import Companies from './companies';
import Contract from './contract';
import CustomerBase from './customer-base';
import Dashboard from './dashboard';
import Developers from './developers';
import ExternalDeliverySupport from './external-delivery-support';
import FeatureFlags from './feature-flags';
import Franchises from './franchises';
import GettingStarted from './getting-started';
import GoingLive from './going-live';
import Home from './home';
import LoyaltyTablet from './loyalty-tablet';
import Marketing from './marketing';
import Menu from './menu';
import MyStore from './my-store';
import OpeningHours from './opening-hours/index';
import OrderSettings from './order-settings';
import Profile from './profile';
import Reservations from './reservations/index';
import RestaurantOnboarding from './restaurant-onboarding';
import Sales from './sales';
import Partners from './partners';
import PartnerPaymentGateway from './partner-payment-gateway';
import PartnerBilling from './partner-billing';
import TestRestaurants from './test-restaurants';
import PartnerAccount from './partner-account';
import PartnerBranding from './partner-branding';
import PartnerTaxCurrency from './partner-tax-currency';
import PartnerServiceFeeCalculator from './partner-service-fee-calculator';
import PartnerProcessingFees from './partner-processing-fees';
import Storefront from './storefront';
import PaymentGateways from './payment-gateways';
import Subscriptions from './subscriptions';
import Team from './team';
import MobileApp from './mobile-app';
import PhoneAnswering from './phone-answering';
import PlatformAgent from './platform-agent';
import GiftCards from './gift-cards';
import TopItems from './top-items';
import WebsiteStudioV2 from './website-studio-v2';

export default {
  AgentOpsQueue,
  Authentication,
  Billing,
  Companies,
  Contract,
  CustomerBase,
  Dashboard,
  Developers,
  ExternalDeliverySupport,
  FeatureFlags,
  Franchises,
  GettingStarted,
  GoingLive,
  Home,
  LoyaltyTablet,
  Marketing,
  Menu,
  MyStore,
  OpeningHours,
  OrderSettings,
  Profile,
  Reservations,
  RestaurantOnboarding,
  Sales,
  Partners,
  PartnerPaymentGateway,
  PartnerBilling,
  TestRestaurants,
  PartnerAccount,
  PartnerBranding,
  PartnerTaxCurrency,
  PartnerServiceFeeCalculator,
  PartnerProcessingFees,
  Storefront,
  PaymentGateways,
  Subscriptions,
  Team,
  MobileApp,
  PhoneAnswering,
  PlatformAgent,
  GiftCards,
  TopItems,
  WebsiteStudioV2,
};
